import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc' // Updated Apollo HOC import
import gql from 'graphql-tag'
import { Row, Col, UncontrolledTooltip, Button } from 'reactstrap'
import DatetimeRenderer from "../../Material/DatetimeRenderer"
import { AllDriverInteractionsQuery, BranchSettingQuery } from "./Queries"
import moment from 'moment'
import AudioPlayer from "./AudioPlayer"
import AttachmentViewer from "./AttachmentViewer"
import './Interactions.css'
import withApolloClient from "../../withApolloClient"

const sendMessageMutation = gql`
mutation sendMessage($input: SendGeneralMessageMutationInput!){
  sendMessage(input:$input){
    ok
    selectedDriversCount
    isSent
    errors{
        messages
    }
  }
}`

const DriverDetailQuery = gql`query Driver($id: ID!){
    driver(id: $id){
        id
        firstName
        lastName
        address
        name
        phone
        customerhandleSet {
            edges {
                node {
                    id
                    type
                    isPrimary
                    isOptedOut
                }
            }
        }
    }
}`
const CurrentUser = gql`
query UserQuery{
    currentUser{
      id
      firstName
      email
    }
}
`
class InteractionsList extends Component {
    constructor(props) {
        super(props)
        this.state = {
            errorMessage: null,
            openModal: "",
            messageBody: "",
            loading: false,
            justSent: null,
            newMessages: [],
        }
    }

    getTenantNameTooltip = (number, index) => {
        let tenantName = this.props.allBranchSettings && this.props.allBranchSettings.edges && this.props.allBranchSettings.edges.filter(setting => setting.node.value === number).filter((settings, index, arr) => arr.findIndex(obj => obj.node.branch.tenant.name === settings.node.branch.tenant.name) === index).map(obj => obj.node.branch.tenant.name).join(" | ")
        return <UncontrolledTooltip placement="right" target={'repUsername' + index}><i className="fa fa-mobile" aria-hidden="true"></i>&nbsp;&nbsp;{tenantName}</UncontrolledTooltip>
    }

    handleSendMessage = async () => {
        const tempId = `temp-${Date.now()}`;
        let fromAddress = this.props.allDriverInteractions[0]?.from_ || this.props.currentUser?.email || "System";

        const tempMessage = {
            id: tempId,
            text: this.state.messageBody,
            from: fromAddress,
            status: "SENDING",
            to: this.props.driver ? this.props.driver.phone : "Driver",
            timestamp: moment().tz("America/New_York"),
        };

        this.setState((prev) => ({ newMessages: [tempMessage, ...prev.newMessages], loading: true, error: null, }));

        try {
            const input = {
                drivers: [this.props.driverId],
                messageText: this.state.messageBody || "",
                messageSubject: this.state.messageSubject || "Message from Support",
                channel: "",
                confirmSend: true,
                overrideMaxDrivers: false,
            };

            const { data } = await this.props.apolloClient.mutate({
                mutation: sendMessageMutation,
                variables: { input },
            });

            if (data?.sendMessage?.ok) {
                this.setState((prev) => ({ newMessages: prev.newMessages.map((msg) => msg.id === tempId ? { ...msg, status: "DELIVERED" } : msg), loading: false, messageBody: "", }));
            } else {
                const error = data?.sendMessage?.errors?.[0]?.messages?.[0] || "An error has occurred. Please contact system admin";

                this.setState((prev) => ({ newMessages: prev.newMessages.map((msg) => msg.id === tempId ? { ...msg, status: "FAILED" } : msg), error, loading: false, }));
            }
        } catch (err) {
            this.setState((prev) => ({ newMessages: prev.newMessages.map((msg) => msg.id === tempId ? { ...msg, status: "FAILED" } : msg), error: `An error has occurred: ${err.message || err}`, loading: false, }));
        }
    };



    render() {
        let prevDate = null
        const driverLoading = this.props.loading || !this.props.driver;

        const isOptedOut = this.props.driver?.customerhandleSet?.edges?.some(edge =>
            edge.node.type === "PHONE" &&
            edge.node.isPrimary &&
            edge.node.isOptedOut
        ) || false;

        return (
            <div className='bos-interaction-wrapper'>
                <Row className="mb-3 d-flex justify-content-end">
                    <Col xs={12}>
                        {driverLoading ? (
                            <p className='text-center' style={{ opacity: ".6" }}><i className="fa fa-spinner fa-spin" aria-hidden="true"></i>&nbsp;&nbsp;Loading driver information...</p>
                        ) : isOptedOut ? (
                            <div style={{ color: 'red', marginBottom: '1rem', textAlign: 'center', whiteSpace: 'pre-line' }}>
                                <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                                {' '}The primary phone number has opted out of SMS.{'\n'}Ask the driver to text "START" to opt back in (US only).
                            </div>
                        ) : (
                            <div className="message-card p-3">
                                <textarea
                                    className="form-control message-input"
                                    rows="3"
                                    placeholder="Type your message..."
                                    value={this.state.messageBody}
                                    onChange={(e) => this.setState({ messageBody: e.target.value })}
                                />
                                <div className="text-right mt-3">
                                    <Button
                                        className="send-btn"
                                        disabled={!this.state.messageBody.trim() || this.state.loading}
                                        onClick={this.handleSendMessage}
                                    >
                                        {this.state.loading
                                            ? "Sending..."
                                            : `Send SMS to ${this.props?.driver?.name ? ` ${this.props?.driver?.name}` : ""}`
                                        }
                                    </Button>
                                </div>
                            </div>
                        )}
                    </Col>
                </Row>
                {/* Sending Message is disabled */}
                {this.state.justSent &&//To fetch message that was just sent due to delay in messages sent and messages fetched
                    <Row className={"outbound-interaction"}>
                        <Col xs={12}>
                            <Row>
                                <Col xs={12}>{"Now"}</Col>
                            </Row>
                        </Col>
                        <Col xs={12}>
                            {this.state.justSent}
                        </Col>
                    </Row>
                }

                {this.state.newMessages.map((msg, index) => (
                    <div key={msg.id} className={"interaction outbound-interaction just-sent-message"}>
                        <span className="interaction-type-icon"><i className="fa fa-comments-o" aria-hidden="true"></i></span>
                        <span className="interaction-details-wrapper">
                            <span className="interaction-details">
                                <span className="interaction-user">
                                    <p>
                                        <span id={`fromUser${index}`}><i className="fa fa-cog" aria-hidden="true"></i>&nbsp;&nbsp;{msg.from || "System"}</span>&nbsp;&nbsp;<i className="fa fa-long-arrow-right" aria-hidden="true"></i>&nbsp;&nbsp;
                                        <span id={`toUser${index}`}><i className="fa fa-mobile" aria-hidden="true"></i>&nbsp;&nbsp;{msg.to} </span>
                                    </p>
                                </span>

                                {msg.text && (
                                    <span className="interaction-msg">
                                        <p>
                                            <i className="fa fa-comments-o" style={{ verticalAlign: "top" }} aria-hidden="true"></i>&nbsp;&nbsp;<span>{msg.text}</span>
                                        </p>
                                    </span>
                                )}
                            </span>
                            <span className="interaction-time">
                                <p>
                                    &nbsp;&nbsp;
                                    {msg.timestamp ? <DatetimeRenderer datetime={msg.timestamp} format={"hh:mm A"} /> : "--"}&nbsp;&nbsp;
                                    {msg.status === "FAILED" ? (
                                        <>
                                            <i style={{ color: "red", fontSize: "13px" }} id={`failed${index}`} className="fa fa-times-circle" aria-hidden="true" />
                                            <UncontrolledTooltip placement="left" target={`failed${index}`}>Failed to send</UncontrolledTooltip>
                                        </>
                                    ) : (
                                        <>
                                            <i style={{ color: "orange", fontSize: "13px" }} id={`sending${index}`} className={`fa fa-spinner ${msg.status === "SENDING" ? "fa-spin" : ""}`} aria-hidden="true" />
                                            <UncontrolledTooltip placement="left" target={`sending${index}`}>Sending...</UncontrolledTooltip>
                                        </>
                                    )}
                                </p>
                            </span>
                        </span>
                    </div>
                ))}
                {this.props.allDriverInteractions && this.props.allDriverInteractions.length > 0 && this.props.allDriverInteractions.map((chat, index) =>
                    <>
                        {function () {
                            if (!prevDate || prevDate !== moment(chat.dateSent).tz("America/New_York").format("dddd, MMMM Do YYYY")) {
                                prevDate = moment(chat.dateSent).tz("America/New_York").format("dddd, MMMM Do YYYY")
                                return <Row>
                                    <Col xs={{ offset: 3, size: 6 }} className="interaction-date">{<DatetimeRenderer datetime={moment(chat.dateSent).format("YYYY-MM-DD")} />}&nbsp;&nbsp;<i className="fa fa-angle-double-down" aria-hidden="true"></i></Col>
                                </Row>
                            } else {
                                prevDate = moment(chat.dateSent).tz("America/New_York").format("dddd, MMMM Do YYYY")
                            }
                        }()}
                        <div key={index} className={"interaction " + (chat.type === "Call" ? "call-interaction " : chat.type === "Office Visit" ? "office-interaction " : "") + (chat.direction && chat.direction.toLowerCase() === "inbound" ? "inbound-interaction" : "outbound-interaction")}>
                            {<span className={"interaction-type-icon"}>
                                {chat.type === "Call" ? <i className="fa fa-phone" aria-hidden="true"></i> : chat.type === "App" ? <i className="fa fa-mobile" aria-hidden="true"></i> : chat.type === "Office Visit" ? <i className="fa fa-building-o" aria-hidden="true"></i> : chat.type === "Email" ? <i className="fa fa-envelope" aria-hidden="true"></i> : chat.type === "Chat" ? <i className="fa fa-comments-o" aria-hidden="true"></i> : <i className="fa fa-mobile" aria-hidden="true"></i>}
                            </span>}
                            <span className='interaction-details-wrapper'>
                                <span className="interaction-details">
                                    <span className='interaction-user'>
                                        <p>
                                            {chat.direction === "Inbound" ? <><i className="fa fa-mobile" aria-hidden="true"></i>&nbsp;&nbsp;{chat.from_}</> : <>
                                                <span id={'repUsername' + index}><i className={"fa " + (chat.rep ? "fa-user-o" : "fa-cog")} aria-hidden="true"></i>&nbsp;&nbsp;{chat.from_} {chat.rep ? chat.rep.firstName ? chat.rep.firstName + " " + chat.rep.lastName : chat.rep.username : " (System)"}</span>
                                                {this.getTenantNameTooltip(chat.from_, index)}
                                            </>}
                                            &nbsp;&nbsp;<i className="fa fa-long-arrow-right" aria-hidden="true"></i>&nbsp;&nbsp;
                                            {chat.direction === "Inbound" ? <>
                                                <span id={'repUsername' + index}><i className={"fa " + (chat.rep ? "fa-user-o" : "fa-cog")} aria-hidden="true"></i>&nbsp;&nbsp;{chat.to} {chat.rep ? chat.rep.firstName ? chat.rep.firstName + " " + chat.rep.lastName : chat.rep.username : " (System)"}</span>
                                                {this.getTenantNameTooltip(chat.to, index)}
                                            </> : <><i className="fa fa-mobile" aria-hidden="true"></i>&nbsp;&nbsp;{chat.to}</>}
                                        </p>
                                    </span>
                                    {chat.attachments && chat.attachments.length > 0 && <span className='interaction-msg'>
                                        {chat.type !== "Call" && chat.attachments.filter(item => item).length > 0 && <i className="fa fa-file-image-o" aria-hidden="true"></i>}
                                        {chat.type === "Call" ? (chat.attachments && chat.attachments.length > 0 ? chat.attachments.map(item => {
                                            return <AudioPlayer audio={item.url} index={index} />
                                        }) : <b>No Audio Found</b>)
                                            :
                                            (
                                                chat.attachments.filter(item => item).map((item, i) =>
                                                    <>
                                                        &nbsp;&nbsp;<i key={i} className="attachment-link fa fa-paperclip" aria-hidden="true" id={`attachment-${i}`} onClick={() => this.setState({ openModal: `ViewAttachment-Message-${index}-attachment-${i}` })}>&nbsp;{item.name}</i>
                                                        {this.state.openModal === `ViewAttachment-Message-${index}-attachment-${i}` && <AttachmentViewer attachment={item} handleClose={() => this.setState({ openModal: "" })} open={this.state.openModal === `ViewAttachment-Message-${index}-attachment-${i}`} />}
                                                    </>)
                                            )}
                                    </span>}
                                    {chat.type !== "Call" && chat.body && <span className='interaction-msg'>
                                        <p>
                                            {chat.type !== "Office Visit" && <> <i className="fa fa-comments-o" style={{ verticalAlign: "top" }} aria-hidden="true"></i>&nbsp;&nbsp; </>}
                                            <span dangerouslySetInnerHTML={{ __html: chat.body }} />
                                        </p>
                                    </span>}
                                </span>
                                <span className='interaction-time'>
                                    <p>&nbsp;&nbsp;{chat.dateSent ? <DatetimeRenderer datetime={chat.dateSent} format={"hh:mm A"} /> : "--"}&nbsp;&nbsp;
                                        {chat.isSent ?
                                            <><i style={{ color: "green", fontSize: "13px" }} id={'success' + index} className="fa fa-check" aria-hidden="true"></i><UncontrolledTooltip placement="left" target={'success' + index}>Delivered</UncontrolledTooltip></> :
                                            <><i style={{ color: "red", fontSize: "13px" }} id={'error' + index} className="fa fa-exclamation-circle" aria-hidden="true"></i><UncontrolledTooltip placement="left" target={'error' + index}>Failed: {chat.clientResponse}</UncontrolledTooltip></>
                                        }
                                    </p>
                                </span>
                            </span>
                        </div>
                    </>
                )}
                {this.props.loading ?
                    <p className='text-center' style={{ opacity: ".6" }}><i className="fa fa-spinner" aria-hidden="true"></i>&nbsp;&nbsp;Loading Driver Interactions...</p> :
                    this.props.allDriverInteractions && this.props.allDriverInteractions.length > 0 ?
                        <>
                            <p className='text-center' style={{ opacity: ".6" }}>Showing last {this.props.allDriverInteractions.length} messages only</p>
                            <Button className={"ghost float-right text-center"} onClick={this.props.loadMoreInteractions} >Show More <i className={"fa fa-caret-down"}></i></Button>
                        </>
                        : <p className='text-center' style={{ opacity: ".6" }}>No interactions found</p>}
            </div>
        )
    }
}

export default graphql(AllDriverInteractionsQuery, {
    options: ({ driverId, interactionType, direction, interactionDate, handles }) => ({
        variables: { id: driverId, interactionDate, interactionType, direction, handles, first: 30 },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'cache-and-network',
    }),
    props({ data: { loading, allDriverInteractions, fetchMore, variables } }) {
        return {
            loading,
            allDriverInteractions,
            refetchAllDriverInteractionsQuery: () => {
                return fetchMore({
                    query: AllDriverInteractionsQuery,
                    variables: {
                        ...variables,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => ({
                        allDriverInteractions: fetchMoreResult.allDriverInteractions,
                    }),
                });
            },
            loadMoreInteractions: () => {
                return fetchMore({
                    query: AllDriverInteractionsQuery,
                    variables: {
                        after:
                            allDriverInteractions && allDriverInteractions.at(-1)
                                ? allDriverInteractions.at(-1).cursor
                                : null,
                        ...variables,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        const newInteractions = fetchMoreResult.allDriverInteractions;
                        return {
                            allDriverInteractions: [
                                ...previousResult.allDriverInteractions,
                                ...newInteractions,
                            ],
                        };
                    },
                });
            },
        };
    },
})(
    graphql(BranchSettingQuery, {
        options: {
            fetchPolicy: 'cache-first',
            variables: { settingName: 'SMS_FROM_DEFAULT' },
        },
        props: ({ data: { loading, allBranchSettings } }) => ({
            loading,
            allBranchSettings,
        }),
    })(
        graphql(DriverDetailQuery, {
            options: ({ driverId }) => ({
                variables: { id: driverId },
                fetchPolicy: 'cache-and-network',
            }),
            props({ data: { driver, loading, variables } }) {
                return { driver, loading, variables };
            },
        })(
            graphql(CurrentUser, {
                options: { fetchPolicy: 'cache-and-network' },
                props: ({ data: { currentUser } }) => ({ currentUser }),
            })(
                withApolloClient(InteractionsList)
            )
        )
    )
);
